<script setup>
import {computed} from 'vue'

import PageEditorSectionMoveDownBtn from "./PageEditorSectionMoveDownBtn.vue"
import PageEditorSectionMoveUpBtn from "./PageEditorSectionMoveUpBtn.vue"
import PageEditorSectionDeleteBtn from "./PageEditorSectionDeleteBtn.vue"
import PageEditorSectionTemplateMenu from "./PageEditorSectionTemplateMenu.vue"
import PageEditorSectionContainerMenu from "./PageEditorSectionContainerMenu.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const activeSectionId = computed(() => pageEditorStore.activeSectionId)

const sectionNumber = computed(() => {
    const sections = pageEditorStore.pageSections || []
    return sections.map(o => o.id).indexOf(activeSectionId.value) + 1
})
</script>

<template>
    <section class="d-flex flex-column gap-2 h-100 p-3">
        <h2 class="h5 mb-3">
            Section {{ sectionNumber }}
            <br>
            <small class="lh-1 text-body-secondary">section</small>
        </h2>

        <PageEditorSectionTemplateMenu/>
        <PageEditorSectionContainerMenu/>
        <PageEditorSectionMoveUpBtn/>
        <PageEditorSectionMoveDownBtn/>
        <PageEditorSectionDeleteBtn/>
    </section>
</template>